export const INFO_APPEND_URL = 'https://www.randstad.co.jp/info_append/';

type CsGuardRoute = 'top' | 'social-insurance';

const hasCsBranch = (search: string): boolean =>
  new URLSearchParams(search).get('branch') === 'cs';

const isInHousePath = (pathname: string, route: CsGuardRoute): boolean =>
  pathname.includes(`/${route}/2`) || pathname.endsWith(`${route}/2`);

export const shouldRedirectToInfoAppend = (
  pathname: string,
  search: string,
  route: CsGuardRoute,
): boolean => {
  if (isInHousePath(pathname, route)) {
    return false;
  }

  return !hasCsBranch(search);
};
